import { useFlags, useLDClient } from "launchdarkly-react-client-sdk";
import { isNil } from "lodash";
import { useEffect } from "react";
import { buildLaunchDarklyUser } from "./buildLaunchDarklyUser";

export function useFlagValue(flag) {
  const flags = useFlags();

  const flagValue = flags[flag.key];
  if (flagValue === undefined) {
    throw new Error(`missing feature flag ${flag.key}`);
  }

  return flagValue;
}

/**
 * Set the user in our feature flag stuff.
 * @param {*} user The user object from our central store.
 * @param {*} organization The organization object from our central store.
 */
export function useSetFeatureFlagUser(user, organization) {
  const ldClient = useLDClient();

  useEffect(() => {
    // if we have user/org data from the
    // session we can update our LD client
    if (!isNil(user) && !isNil(organization)) {
      const launchDarklyUserData = buildLaunchDarklyUser(user, organization);
      ldClient.identify(launchDarklyUserData);
    }
  }, [user, organization]); // update ld client when user or org changes
}
